import React, { Component } from 'react';
import './App.css';
import { RedocStandalone } from 'redoc';


class App extends Component {
  render() {
    return (
      <div className="App">
        <div className="navbar">
          <img src='asset/logo.png' alt="Logo" />
        </div>
        <div className="redocDiv">
          <RedocStandalone
            specUrl="./data.json"
            options={{
              nativeScrollbars: false,
              scrollYOffset: 60,

              theme: { colors: { main: '#dd5522' } },
            }}
          />
        </div>
      </div>
    );
  }
}

export default App;
